import React, { Component } from "react";
import { fire, auth } from "../../firebase/index";

import Switch from "react-switch";
//css
import "../../assets/css/maincss.css";
import "../../assets/css/header.css";
import LocalizedStrings from "react-localization";
let localizationStrings = new LocalizedStrings({
  en: {},
  ja: {},
  es: {},
});

class ThemeSetting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      darkMode: false,
    };

    //? Functions
    // this.handleChange = this.handleChange.bind(this);
  }

  componentWillMount() {
    // fire
    //   .database()
    //   .ref("userSettings")
    //   .child(auth.currentUser.uid)
    //   .once("value")
    //   .then(snapshot => {
    //     //? use oppositeBoolean because the switch button take false = enabled and true = disable
    //     //? isBatteryNotificationCompleted true = disabled and false = enabled
    //     var oppositeBoolean = null;
    //     if (snapshot.exists) {
    //       if (snapshot.val().isBatteryNotificationDisabled === true) {
    //         oppositeBoolean = false;
    //         this.setState({
    //           batteryMode: oppositeBoolean
    //         });
    //       } else {
    //         oppositeBoolean = true;
    //         this.setState({
    //           batteryMode: oppositeBoolean
    //         });
    //       }
    //     }
    //   });
  }

  // handleChange() {
  //   let currentBatteryMode = this.state.batteryMode;

  //   const userSettingDB = fire
  //     .database()
  //     .ref("userSettings")
  //     .child(auth.currentUser.uid);

  //   userSettingDB
  //     .once("value")
  //     .then(snapshot => {
  //       if (snapshot.exists) {
  //         if (
  //           snapshot.val().isBatteryNotificationDisabled !== undefined ||
  //           snapshot.val().isBatteryNotificationDisabled !== null
  //         ) {
  //           userSettingDB.update({
  //             isBatteryNotificationDisabled: currentBatteryMode
  //           });
  //         }
  //       }
  //     })
  //     .then(() => {
  //       this.setState({
  //         darkMode: !currentBatteryMode
  //       });
  //     });
  // }

  render() {
    return (
      <Switch
        // onChange={this.handleChange}
        checked={this.state.darkMode}
        id="normal-switch"
      />
    );
  }
}

export default ThemeSetting;
